import "!../node_modules/mini-css-extract-plugin/dist/loader.js?{}!css-loader?{\"modules\":false,\"url\":false}!./pages.treat.1UD4qGZ.css";
export var stationsStyles = {tilePastBox:'_1KItp',tilePresentBox:'_35YLF'};